import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state() {
    return {
      entity: null,
      id: null,
      versionId: null,
      relativeVersionId: null,
      errors: [],
      master: {},
      draft: {},
      fieldsConfig: {},
      advancedMode: false,
    };
  },
  actions,
  getters,
  mutations,
};
